var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerVideoLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.45 7.11-6-3A1 1 0 0 0 8 5v6a1 1 0 0 0 .47.85A1 1 0 0 0 9 12a1 1 0 0 0 .45-.11l6-3a1 1 0 0 0 0-1.78zM10 9.38V6.62L12.76 8zM20 17a3 3 0 0 0-2.82 2H13v-4h6a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h6v4H6.82a3 3 0 1 0 0 2h10.36A3 3 0 1 0 20 17zM4 12V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm0 9a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm16 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1z",
    "data-name": "27 Video Link, Camera, Film",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerVideoLink);
export default __webpack_public_path__ + "static/media/server-video-link.6f342b182dc0a6ec8149eac81d5e9768.svg";
export { ForwardRef as ReactComponent };